import * as React from 'react'

import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'

import { cn } from '../utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-full font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-primary-button text-primary-foreground hover:bg-primary-button-darker-75 hover:text-primary-foreground focus:text-primary-foreground active:text-primary-foreground',
        cd: 'bg-primary-button-cd text-primary-foreground hover:bg-primary-button-cd-darker-75',
        secondary:
          'bg-secondary-button text-secondary-foreground hover:bg-secondary-button-darker-75',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline:
          'text-[#4E4E4E] border border-[#4E4E4E] bg-background hover:bg-accent hover:text-accent-foreground active:text-accent-foreground focus:text-accent-foreground',
        ghost: 'rounded-md hover:bg-accent hover:text-accent-foreground',
        link: 'text-link underline-offset-4 !hover:underline !px-0 !py-0 !h-auto focus-visible:ring-0',
        completed:
          'bg-white text-[#2F2F2F] hover:!bg-accent focus:bg-accent focus:border-accent active:bg-accent active:border-accent border-2 border-[#2F2F2F]',
        selected: 'bg-primary-button-darker-75 text-primary-foreground',
        coachcta:
          'bg-intoo-green-coachcta text-white hover:bg-intoo-green-coachcta-hover hover:text-white focus:text-white active:text-white',
        coach_linkedin:
          'bg-white text-intoo-green-coachcta border border-intoo-green-coachcta',
        select:
          'bg-select-blue text-white hover:bg-select-blue-darker-75 hover:text-white focus:text-white active:text-white',
      },
      size: {
        default: 'h-10 px-8 py-2',
        venti: 'h-auto min-h-14 px-4 py-1',
        sm: 'h-9 px-3 text-sm',
        md: 'h-10 px-6 text-base',
        lg: 'h-12 px-12 text-lg text-lg',
        xl: 'h-[3.75rem] px-16 text-xl',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
)

const LinkButton = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'a'
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
LinkButton.displayName = 'LinkButton'

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
Button.displayName = 'Button'

export { Button, LinkButton, buttonVariants }
